import { requestApi } from './Api';

export const getRefundReceipt = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/refund_receipt/get',
    params
  });

export const generateRefundReceiptPdf = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/refund_receipt/pdf',
    params,
    responseType: 'blob'
  });
